module.exports = __webpack_public_path__ + "img/cardapioFill.8424fb6b.svg";